import { Flex, HoverCard, Paper, Stack, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  CivilSectorExperienceSvg,
  DiverseIndustryExposureSvg,
  EmailManagerSvg,
  ShortTermEntrepreneurshipSvg,
  SpecialistToManagerSvg,
} from "../../../shared/svg";
import { LikeResponse } from "../../../entities/components/LikeResponse";
import "../Report.scss";
import useReportStore from "../../../store/useReportStore";

export const CareerMilestones = () => {
  const matches = useMediaQuery("(max-width: 1100px)");
  const { report, reportId } = useReportStore();

  const milestonesData = report?.milestones || [];

  if (milestonesData.data.length === 0) {
    return (
      <Paper radius="24px" p="32px" mt={32} withBorder>
        <Title size={36} mb={8}>
          Loading career milestones...
        </Title>
        <Text c="dimmed">Please wait while we fetch your data.</Text>
      </Paper>
    );
  }

  const icons = (
    <Flex
      mx={matches ? 0 : 40}
      my={matches ? 0 : 40}
      mb={matches ? 130 : 0}
      justify="space-between"
      pos="relative"
      direction={matches ? "column" : undefined}
    >
      <div className="timeline" />
      <EmailManagerSvg />
      <SpecialistToManagerSvg />
      <CivilSectorExperienceSvg />
      <ShortTermEntrepreneurshipSvg />
      <DiverseIndustryExposureSvg />
    </Flex>
  );

  const content = {
    title: milestonesData?.mark_down
      ? milestonesData?.mark_down?.replace(/^## /, "")
      : "",
    description: milestonesData?.explanation ? milestonesData?.explanation : "",
  };

  return (
    <Paper radius="24px" p="32px" mt={32} withBorder>
      <Title
        size={matches ? 24 : 36}
        mb={8}
        style={{ wordBreak: "break-word" }}
      >
        {content.title}
      </Title>
      <Text style={{ fontSize: matches ? 16 : 18 }} mb={24} c="dimmed">
        {content.description}
      </Text>
      <Flex gap={16} className="career-milestones">
        {matches && icons}
        <Stack
          gap={matches ? 40 : 0}
          ta={matches ? undefined : "center"}
          w="100%"
        >
          <Flex
            justify="space-between"
            align="center"
            gap={matches ? 40 : 0}
            direction={matches ? "column" : undefined}
          >
            {milestonesData.data.slice(0, 3).map((milestone, index) => {
              const maxLength = 130;
              const truncatedDescription =
                milestone.description.length > maxLength
                  ? milestone.description.slice(0, maxLength) + "..."
                  : milestone.description;

              return (
                <HoverCard key={index} width={280} shadow="md" position="top">
                  <HoverCard.Target>
                    <Text maw={matches ? 199 : 208} mih={200}>
                      <b>{milestone.title}</b> <br /> {truncatedDescription}
                    </Text>
                  </HoverCard.Target>
                  <HoverCard.Dropdown>
                    <Text key={index} maw={matches ? 199 : 208} mih={200}>
                      <b>{milestone.title}</b> <br /> {milestone.description}
                    </Text>
                  </HoverCard.Dropdown>
                </HoverCard>
              );
            })}
          </Flex>
          {!matches && icons}
          <Flex
            justify={matches ? "space-around" : "space-between"}
            align="center"
            mt={matches ? 0 : 40}
            gap={matches ? 40 : 0}
            px={matches ? 0 : "20%"}
            direction={matches ? "column" : undefined}
          >
            {milestonesData.data.slice(3).map((milestone, index) => {
              const maxLength = 130;
              const truncatedDescription =
                milestone.description.length > maxLength
                  ? milestone.description.slice(0, maxLength) + "..."
                  : milestone.description;

              return (
                <HoverCard key={index} width={280} shadow="md" position="top">
                  <HoverCard.Target>
                    <Text key={index} maw={matches ? 199 : 208} mih={200}>
                      <b>{milestone.title}</b> <br /> {truncatedDescription}
                    </Text>
                  </HoverCard.Target>
                  <HoverCard.Dropdown>
                    <Text key={index} maw={matches ? 199 : 208} mih={200}>
                      <b>{milestone.title}</b> <br /> {milestone.description}
                    </Text>
                  </HoverCard.Dropdown>
                </HoverCard>
              );
            })}
          </Flex>
        </Stack>
      </Flex>
      <LikeResponse report_id={reportId} section="milestones" />
    </Paper>
  );
};
